import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Link from '@/components/Link';

const FooterLink = styled(Link)`
  position: relative;
  color: inherit;
  display: block;
  text-decoration: none;

  /* Increase touch target on smaller screens */
  @media (max-width: 67.125rem) {
    padding-block: 4px;
  }

  /* On larger screens, we don't want to increase the block size, but we do want to increase the tap target size */
  @media (min-width: 67.125rem) {
    padding-block: 2px;

    &::before {
      content: '';
      position: absolute;
      inset: -4px;
    }
  }

  &:hover {
    font-weight: var(--font-weight-medium);
    color: var(--color-text);
  }
`;

export default FooterLink;
